import React, { useState, useEffect } from "react";
import "./Resources.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import { sanityClient } from "./sanityClient";

const Resources = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 12;

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const query = `*[_type == "post"] | order(publishedAt desc) {
          _id,
          title,
          slug,
          publishedAt,
          description,
          thumbnail{asset->{url}, alt, caption}
        }`;
        const data = await sanityClient.fetch(query);
        setPosts(data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching posts:", err);
        const errorMsg = err.response?.status
          ? `HTTP ${err.response.status}: ${err.message}`
          : err.message;
        setError(errorMsg);
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const totalPages = Math.ceil(posts.length / postsPerPage);
  const startIndex = (currentPage - 1) * postsPerPage;
  const currentPosts = posts.slice(startIndex, startIndex + postsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((page) => page + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((page) => page - 1);
    }
  };

  return (
    <main className="resources-page">
      <Helmet>
        <meta
          name="description"
          content="Professional SEO services in Ottawa. Improve your search engine rankings, drive more traffic, and grow your business with our proven SEO strategies."
        />
        <title>Resources | Attoli</title>
        <link rel="canonical" href="https://attoli.com/resources" />
      </Helmet>
      <section className="resources-hero">
        <div className="wrap">
          <h1>Resources</h1>
          <p>Free content to help grow and manage your accounting website.</p>
        </div>
      </section>
      <section className="resources-section wrap">
        <h2>Latest Content Posts</h2>
        {loading && <p>Loading blog posts...</p>}
        {error && <p style={{ color: "red" }}>Error loading posts: {error}</p>}
        {!loading && !error && (
          <>
            <ul className="blog-list">
              {currentPosts.length > 0 ? (
                currentPosts.map((p) => (
                  <li key={p._id} className="blog-card">
                    <Link
                      to={`/content/${p.slug?.current}`}
                      className="thumb-link"
                    >
                      <img
                        src={p.thumbnail?.asset?.url || ""}
                        alt={p.thumbnail?.alt || p.title}
                        className="blog-thumb"
                      />
                    </Link>
                    <h3 className="resources-post-title">
                      <Link to={`/content/${p.slug?.current}`}>{p.title}</Link>
                    </h3>
                    {p.publishedAt && (
                      <div className="resources-post-date">
                        {new Date(p.publishedAt).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </div>
                    )}
                  </li>
                ))
              ) : (
                <li>No blog posts yet. Check back soon!</li>
              )}
            </ul>

            {totalPages > 1 && (
              <div className="pagination-wrap">
                {currentPage > 1 && (
                  <button
                    type="button"
                    className="page-button"
                    onClick={handlePreviousPage}
                  >
                    Previous Page
                  </button>
                )}

                {currentPage < totalPages && (
                  <button
                    type="button"
                    className="page-button next-page-button"
                    onClick={handleNextPage}
                  >
                    Next Page
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </section>
      <Footer />
    </main>
  );
};

export default Resources;
